import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import type { ReactNode } from 'react';

import { DataSourceBadge } from '../data/DataSourceBadge';
import type { DataSource } from '../../config/capabilities';

export interface DetailHeaderProps {
  readonly actions?: ReactNode;
  readonly backTo?: string;
  readonly dataSource?: DataSource;
  readonly subtitle?: ReactNode;
  readonly title: ReactNode;
}

export function DetailHeader({ actions, backTo, dataSource, subtitle, title }: DetailHeaderProps) {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} sx={{ mb: 3 }}>
      {backTo === undefined ? null : (
        <Button component={RouterLink} size="small" to={backTo} variant="text">
          {t('pageState.back')}
        </Button>
      )}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        sx={{ alignItems: { sm: 'flex-start' }, justifyContent: 'space-between' }}
      >
        <div>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Typography component="h1" variant="h4">
              {title}
            </Typography>
            {dataSource === undefined ? null : <DataSourceBadge source={dataSource} />}
          </Stack>
          {subtitle === undefined ? null : (
            <Typography color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </div>
        {actions === undefined ? null : (
          <Stack direction="row" spacing={1}>
            {actions}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
